/**
 * Created by wacelBaroudi on 07/02/2019.
 */

angular.module('FlexyBeautyApp.services').factory('KycDocument_Resource', ["$resource", "$location",
    function ($resource, $location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + "rest/kyc/documents", {}, {
            query: {method: 'GET', isArray: true}
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('KycDocument', ["KycDocumentData",
    function (KycDocumentData) {
        let KycDocument = function (resource) {
            this.type = null;
            this.status = null;
            this.refusedReasonMessage = null;

            if (resource !== undefined && resource !== null)
                this.loadObject(resource);

            KycDocumentData.add(this);
        };

        KycDocument.prototype.loadObject = function (object) {
            if (object) {
                this.type = object.type;
                this.status = object.status;
                this.refusedReasonMessage = object.refusedReasonMessage;
            }
        };

        return KycDocument;
    }
]);

angular.module('FlexyBeautyApp.services').factory('KycDocumentSrv', ["$log", "ServerSrv", "KycDocument_Resource", "KycDocumentData", "KycDocument",
    function ($log, ServerSrv, KycDocument_Resource, KycDocumentData, KycDocument) {
        let KycDocumentSrv = {};

        KycDocumentSrv.query = function (successFunction, errorFunction) {
            KycDocument_Resource.query(
                {},
                function (data) {

                    KycDocumentData.clear();
                    for (let i = 0; i < data.length; i++) {
                        new KycDocument(data[i]);
                    }

                    if (successFunction !== undefined)
                        successFunction();
                },
                function (data) {
                    if (errorFunction !== undefined)
                        errorFunction(data);
                }
            );
        };

        return KycDocumentSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('KycDocumentData', ["$filter",
    function () {
        let kycDocumentData = {
            kycDocuments: []
        };
        kycDocumentData.getActiveList = function () {
            return this.kycDocuments;
        };
        kycDocumentData.clear = function () {
            this.kycDocuments = [];
        };
        kycDocumentData.add = function (kycDocument) {
            this.kycDocuments.push(kycDocument);
        };
        return kycDocumentData;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/KycDocument.js